import React, {useEffect, useState} from "react";
import "./PeykMap.scss";
import {Map} from "../Map/Map";
import {PackManHederBack} from "../../PackMan/PackManHederBack/PackManHederBack";
import {useLocation} from "react-router-dom";

function PeykMap() {
    const [coordinate,set_coordinate] = useState({lat:35.6892,lng:51.3890});

    const location = useLocation();

    useEffect(()=>{
        if(location.state && location.state.position){
            console.log("position : ",location.state)
            set_coordinate(location.state.position)
            //history.replace('/verify',{...location.state,token:""});
        }
    },[])

    return(
        <div>
            <PackManHederBack title={"مقصد سفارش"}/>
            <Map coordinate={coordinate} />
        </div>
    )
}

export {PeykMap}
